// removed by extract-text-webpack-plugin
module.exports = {"OrderButtons":"OrderButtons__OrderButtons__18q2n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/OrderButtons/OrderButtons.css
// module id = 250
// module chunks = 1